<template>
  <v-row v-if="products.length" class="ma-0" no-gutters>
    <v-col>
      <slot name="title">
        <h2 class="text-break homepageTitle mb-1">
          {{ title }}
        </h2>
      </slot>

      <ItemGroup :items="products">
        <template v-slot:item="{ item }">
          <v-hover v-slot="{ hover }">
            <v-card
              class="colorCard"              
              width="100%"
              height="100%"
              :elevation="hover ? 5 : 1"
              @click="productSelected(item)"
            >
              <!-- image of the product -->
              <v-img :aspect-ratio="1.618 / 1" :src="item.PictureUrl">
                <!-- Highlighting label -->
                <HighlightingLabel
                  :label="item.HighlightingLabel"
                  :visible="item.Highlighted"
                />

                <!-- sold out text -->
                <div
                  v-if="!hasCapacity(item)"
                  class="red--text text-h6 font-weight-bold sold-out-lable"
                >
                  {{ $translate('PRODUCT_SOLD_OUT') }}
                </div>

                <!-- button -->
                <TrendingProductsButtons
                  :product="item"
                  :absoluteTopRight="true"
                  @add="openProductDialog(item)"
                  @info="productSelected(item)"
                />
              </v-img>

              <div class="pa-2 text-subtitle-1 text-center text-truncate">
                {{ item.Name }}
              </div>

              <div
                class="px-2 pb-3 text-center itemTitleFontSize"
                style="min-height: 80px"
              >
                <v-col class="pa-0">
                  <!-- Unit price -->
                  <v-row
                    v-if="showPrice(item)"
                    class="ma-0 text--primary d-inline-flex"
                    justify="center"
                    align="baseline"
                  >
                    <div
                      v-if="onDiscount(item)"
                      class="discount-price text-body-2 mr-1"
                    >
                      {{ formatter.format(getShownRetailUnitPrice(item)) }}
                    </div>
                    <v-row class="ma-0" justify="center" align="baseline">
                      <div>
                        <span
                          class="text-h6"
                          :class="hasGeneralDiscount(item) ? 'red--text' : ''"
                        >
                          {{ formatter.format(getShownUnitPrice(item)) }}
                        </span>
                        <span
                          v-if="isWeightedProduct(item)"
                          class="text-caption"
                        >
                          /
                          <span v-if="item.WeightedInfo.OverviewSize > 1">
                            {{ item.WeightedInfo.OverviewSize }}
                          </span>
                          {{ item.WeightedInfo.Unit }}
                        </span>
                      </div>
                      <span class="text-caption text--secondary ml-1">
                        {{ priceSuffix }}
                      </span>
                    </v-row>
                  </v-row>

                  <!-- Minimum quantity -->
                  <div
                    v-if="
                      getDisplayMinQuantity(item) > getDisplayStepSize(item)
                    "
                    class="text-caption text--primary"
                  >
                    Minimum
                    {{ getDisplayMinQuantity(item) }}
                    {{ getDisplayUnit(item) }}
                  </div>

                  <!-- availability info  -->
                  <v-row
                    class="pa-0 pt-1 pb-3"
                    v-if="
                      item.AvailabilityBatchGroup != null &&
                      item.AvailabilityBatchGroup.BatchGroupId != 0
                    "
                  >
                    <ProductAvailabilityInfo></ProductAvailabilityInfo>
                  </v-row>
                </v-col>
              </div>
            </v-card>
          </v-hover>
        </template>
      </ItemGroup>
    </v-col>
  </v-row>
</template>

<script>
import trendingProductsMixin from '@/mixins/trendingProducts';
import ItemGroup from '@/components/generalComponents/uiComponents/ItemGroup';
import ProductAvailabilityInfo from '@/components/event/eventDetails/productOrderComponents/ProductAvailabilityInfo';

export default {
  name: 'TrendingProducts',
  mixins: [trendingProductsMixin],
  components: {
    ItemGroup,
    ProductAvailabilityInfo,
  },
  methods: {
    initPrimaryColorWithOpacity() {
      const opacityHexValue = '26';
      const selector = document.querySelector(':root');
      selector.style.setProperty(
        '--primary-color-opacity1',
        `${this.$vuetify.theme.themes.light.primary}${opacityHexValue}`
      );
    },
  }
};
</script>

<style scoped lang="scss">
.sold-out-lable {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
};
.colorCard{
  background-color: var(--primary-color-opacity1);
};

</style>
